import { render, staticRenderFns } from "./return-to-login.vue?vue&type=template&id=1f7ec5e0&scoped=true&"
import script from "./return-to-login.vue?vue&type=script&lang=js&"
export * from "./return-to-login.vue?vue&type=script&lang=js&"
import style0 from "./return-to-login.vue?vue&type=style&index=0&id=1f7ec5e0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7ec5e0",
  null
  
)

export default component.exports